import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePageTitle } from "hooks/usePageTitle";
import { UserData } from "modules/authentication/types/user-data";

import { useMediaQuery } from "@/hooks/use-media-query";
import { cn } from "@/lib/utils";


import { useAuth } from "modules/authentication/hooks/use-auth";
import { PlusUpsellBanner } from "modules/subscription/components/PlusUpsellBanner";
import { ListsDashboard } from "modules/lists/components/ListsDashboard";
import { useLists } from "modules/lists/context/ListsContext";
import { usePersistOnboardingData } from "modules/onboarding/hooks/use-persist-onboarding-data";

import { useFeatureFlagEnabled } from "posthog-js/react";
import { UsersDashboard } from "modules/users/components/user-dashboard";

const getUserData = () => {
  try {
    const data = localStorage.getItem("userData");
    return data ? (JSON.parse(data) as UserData) : ({} as UserData);
  } catch (error) {
    console.warn("Error reading userData:", error);
    return {} as UserData;
  }
};
export const MainPage = () => {
  const { setTitle,setShowBack } = usePageTitle();
  const { isLogged } = useAuth();
  const { lists, createList } = useLists();
  const navigate = useNavigate();
  const [userData, setUserData] = useState<UserData>({} as UserData);

  useEffect(() => {
    setTitle("Mi panel de ahorro");
    setShowBack(false);
  }, [setTitle]);

  const [userIsConfigured, setUserIsConfigured] = useState(
    userData.settings_set,
  );
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  useEffect(() => {
    //cargar indicador de primer uso
    try {
      // localStorage.setItem("visitor", "true");
    } catch (error) {
      console.warn("Error writing visitor flag:", error);
    }

    // Cargar userData actualizado
    const currentUserData = getUserData();
    setUserData(currentUserData);
    setUserIsConfigured(currentUserData.settings_set || false);
  }, []);



  /**
   * Fire-and-forget side effect: persist the onboarding draft to the
   * backend once the authenticated user lands on /store and the auth
   * contract says they completed the wizard. The hook self-guards on
   * prerequisites and dedupes StrictMode double-mounts.
   */
  usePersistOnboardingData(async () => {
    if (lists.length === 0) {
      const newList = await createList("Mi primera lista en Carriapp", "");
      navigate(`/lists/${newList.id}`, { state: { isNew: true } });
    }
  });


  //feature flag, remove in future iterations
  const flagEnabled = useFeatureFlagEnabled("list-release");

  return (
    <>
      <div className="noto-sans-regular bg-[#F8F8F8] h-full">
        <div className="flex flex-col w-full 2xl:w-[80%] mx-auto px-4 mt-8  gap-8">
          {isLogged && flagEnabled && (
            <>
              <div className="flex flex-col w-full gap-4">
                <h2
                  className={cn(
                    "font-bold",
                    {
                      "text-3xl": isDesktop,
                      " text-2xl": !isDesktop,
                    },
                  )}
                >
                  ¡Hola {userData.first_name || "Usuario"}!
                </h2>
                <p className="text-xl text-muted-foreground">
                  ¿En qué vamos a ahorrar hoy?
                </p>
              </div>
            </>
          )}
          <UsersDashboard />
          <div>
            <h2 className="font-semibold text-xl">Tus listas</h2>
            <ListsDashboard className="mt-4" />
          </div>
        </div>
      </div>
    </>
  );
};



